import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./TeamCard.css";

function TeamCard({ singleProjectData }) {
  // console.log(singleProjectData.pentesters)
  return (
    <div className="isecurion_single_project_team_card_container">

      {singleProjectData?.pentesters?.length > 0 ? (singleProjectData?.pentesters?.map((pentester, index) => (
        <div className="isecurion_single_project_team_card_half_details" key={pentester._id || index}>
          <div className="isecurion_single_project_team_card_profile_icon">{pentester.charAt(0).toUpperCase()}</div>
          <div className="isecurion_single_project_team_card_details">
            <div className="isecurion_single_project_team_card_name">
              {pentester}
            </div>
            <div className="isecurion_single_project_team_card_role">
              Pentester
            </div>
          </div>
        </div>
      ))) : ''}

    </div>
  );
}


export default TeamCard;